// @module BluePoint.VerifyEmail.VerifyEmail
define('BluePoint.VerifyEmail.VerifyEmail.View'
,   [
    'bluepoint_verifyemail_verifyemail.tpl',

    'BluePoint.VerifyEmail.VerifyEmail.SS2Model',

    'Backbone',
    'jQuery'
    ]
, function (
    bluepoint_verifyemail_verifyemail_tpl,

    VerifyEmailSS2Model,

    Backbone,
    jQuery
)
{
    'use strict';

    return Backbone.View.extend({

        template: bluepoint_verifyemail_verifyemail_tpl,

        initialize: function (options) {
            var self = this;
            this.application = options.application;
            this.environment = options.environment;
            this.model = new VerifyEmailSS2Model();

            this.options.VerifyRegisterPage.on('beforeRegister', function () {
                self.options.VerifyRegisterPage.registerDefer = jQuery.Deferred();
                var firstname, lastname, email, password, password2, country, state, phone = '';

                firstname = jQuery('input[name="firstname"]').val();
                lastname = jQuery('input[name="lastname"]').val();
                email = jQuery('input[id="register-email"]').val();
                password = jQuery('input[id="register-password"]').val();
                password2 = jQuery('input[name="password2"]').val();
                country = jQuery('input[name="custentity_reg_country"]').val();
                state = jQuery('select[name="custentity_reg_state"]').val();
                phone = jQuery('input[name="custentity_registration_phone"]').val();

                if (firstname != '' && lastname != '' && email != '' && password != '' && password2 != '' && country != '' && phone != '' && state) {
                    // REQUEST OTP (or check already verified)
                    self.model.fetch({
                        data: {
                            action: 'send_otp',
                            email: email
                        }
                    }).done(function (response) {
                        if (response.alreadyVerified) {
                            // Verified recently — skip OTP
                            if (self.options.VerifyRegisterPage.registerDefer) {
                                self.options.VerifyRegisterPage.registerDefer.resolve();
                            }
                            return;
                        }

                        if (response.success) {
                            jQuery('.login-register-register-form-submit').prop('disabled', true);

                            // Store recordId locally (for fallback in case session lost)
                            self.otpRecordId = response.recordId;

                            // Create a fresh instance and show modal
                            let newView = new (self.constructor)({
                                application: self.application,
                                environment: self.environment,
                                VerifyRegisterPage: self.options.VerifyRegisterPage
                            });

                            newView.showOTPModal(email);
                        } else {
                            alert(response.message || 'Failed to send OTP.');
                            if (self.options.VerifyRegisterPage.registerDefer) {
                                self.options.VerifyRegisterPage.registerDefer.reject();
                            }
                        }
                    }).fail(function (jqXHR, textStatus, errorThrown) {
                        alert('Failed to send OTP. Please try again.');
                        if (self.options.VerifyRegisterPage.registerDefer) {
                            self.options.VerifyRegisterPage.registerDefer.reject();
                        }
                    });

                    return self.options.VerifyRegisterPage.registerDefer.promise();
                } else {
                    // Not all fields present; allow normal validation to show error
                }
            });
        },

        events: {
            'click [data-action="submit-otp"]': 'submitOTP',
            'click [data-action="resend-otp"]': 'resendOTP'
        },

        //--------------------------------------------
        // SHOW OTP MODAL
        //--------------------------------------------
        showOTPModal: function (email) {
            let self = this;
            this.email = email;

            this.modal_title = "Verification Code";
            this.message = "A 6-digit OTP has been sent to: " + email;

            this.application.getLayout().showInModal(this, {
                className: 'otp-verification-modal',
                showFooter: false,
                preventClosing: true
            });

            // Prevent modal closing when clicking outside
            setTimeout(function () {
                jQuery('.modal-backdrop').off('click');
                jQuery('.modal').off('click');

                jQuery('.modal .close, .modal [data-dismiss="modal"]').off('click').on('click', function (e) {
                    e.stopPropagation();
                    self.closeModal();
                });
            }, 300);

            this.once('afterViewRender', function () {
                jQuery('#in-modal-otp-input').focus();
                self.startTimer();
            });
        },

        //--------------------------------------------
        // SUBMIT OTP
        //--------------------------------------------
		submitOTP: function () {
		    let otp = jQuery('#in-modal-otp-input').val();
		    if (!otp || otp.length !== 6) {
		        alert("Please enter a valid 6-digit OTP.");
		        return;
		    }
		
		    let self = this;
		
		    this.model.fetch({
		        data: {
		            action: 'verify_otp',
		            otp: otp
		        }
		    }).done(function (response) {
			
		        // ===== SUCCESS =====
		        if (response.success) {
		            self.closeModal();
		            jQuery('.login-register-register-form-submit').prop('disabled', false);
				
		            if (self.options.VerifyRegisterPage.registerDefer) {
		                self.options.VerifyRegisterPage.registerDefer.resolve();
		            }
		            return;
		        }
			
		        // ===== OTP BLOCKED AFTER MAX ATTEMPTS =====
		        if (response.message == "Too many incorrect attempts. OTP locked.") {
				
		            // Disable submit button
		            jQuery('.otp-submit-btn')
		                .addClass('expired')
		                .prop('disabled', true);
				
		            // Disable OTP input + grey it out
		            jQuery('#in-modal-otp-input')
		                .prop('disabled', true)
		                .css({
		                    'background-color': '#e6e6e6',
		                    'cursor': 'not-allowed',
		                    'opacity': '0.6'
		                });
					
		            // Add OTP Locked message under timer (if not already added)
		            if (jQuery('.otp-locked-message').length === 0) {
		                jQuery('.otp-timer-text')
		                    .after('<div class="otp-locked-message" style="margin-top:10px;color:#c0392b;font-weight:bold; text-align:center;">OTP Locked — Too many incorrect attempts.</div>');
		            }
				
		            alert(response.message || "Too many incorrect attempts. OTP locked.");
		            return;
		        }
			
		        // ===== NORMAL INVALID OTP =====
		        alert(response.message || 'Invalid OTP. Please try again.');
			
		    }).fail(function () {
		        alert('OTP verification failed. Please try again.');
		        if (self.options.VerifyRegisterPage.registerDefer) {
		            self.options.VerifyRegisterPage.registerDefer.reject();
		        }
		    });
		},


        //--------------------------------------------
        // RESEND OTP
        //--------------------------------------------
        resendOTP: function () {
            let self = this;

            // Try to pass recordId as fallback; service will use session or fallback parameter
            this.model.fetch({
                data: {
                    action: 'resend_otp',
                    recordId: this.otpRecordId || ''
                }
            }).done(function (response) {
                if (response.success) {
                    // reset timer for 5 minutes and disable resend until 30s
					// Disable OTP input + grey it out
		            jQuery('#in-modal-otp-input')
		                .prop('disabled', false)
		                .css({
		                    'background-color': '',
		                    'cursor': '',
		                    'opacity': ''
		                });
					jQuery('#in-modal-otp-input').val('');
					jQuery('.otp-locked-message').remove();
                    alert(response.message || 'OTP resent successfully!');
                    self.startTimer(); // restart 5min timer
                } else {
					if(response.message == "Maximum resend attempts reached.") {
						// Disable resend button
		            	jQuery('.otp-resend-btn')
		                	.removeClass('active')
		                	.addClass('expired')
		                	.prop('disabled', true);
							
                    	alert(response.message || 'Maximum resend attempts reached.');
					}
					else {
                    	alert(response.message || 'Failed to resend OTP.');
					}
                }
            }).fail(function () {
                alert('Failed to resend OTP. Please try again.');
            });
        },

        //--------------------------------------------
        // START TIMER (5 minutes)
        //--------------------------------------------
        startTimer: function () {
            let self = this;
            let duration = 5 * 60; // 5 minutes

            // Disable resend initially
            jQuery('.otp-resend-btn')
                .addClass('disabled')
                .removeClass('active')
                .prop('disabled', true);

            jQuery('.otp-submit-btn')
                .removeClass('expired')
                .prop('disabled', false);

            // Clear existing interval if any
            if (this.timerInterval) {
                clearInterval(this.timerInterval);
            }

            // Show countdown immediately
            function updateTimerText(d) {
                let minutes = Math.floor(d / 60);
                let seconds = d % 60;
                let timeString =
                    (minutes < 10 ? "0" + minutes : minutes) + ":" +
                    (seconds < 10 ? "0" + seconds : seconds);
                jQuery('.otp-timer-text').text("Time remaining: " + timeString);
            }

            updateTimerText(duration);

            // Make resend button become enabled only after OTP expires (per your earlier logic)
            this.timerInterval = setInterval(function () {
                if (duration <= 0) {
                    clearInterval(self.timerInterval);
                    jQuery('.otp-timer-text').text("OTP expired. Please resend.");
                    jQuery('.otp-resend-btn')
                        .removeClass('disabled')
                        .addClass('active')
                        .prop('disabled', false);
                    jQuery('.otp-submit-btn')
                        .addClass('expired')
                        .prop('disabled', true);
                    return;
                }
                duration--;
                updateTimerText(duration);
            }, 1000);
        },

        closeModal: function () {
            if (this.timerInterval) {
                clearInterval(this.timerInterval);
            }
            jQuery('.modal').modal('hide');
        },

        bindings: {},

        childViews: {},

        getContext: function getContext() {
            return {
                modal_title: this.modal_title || 'Verification Code',
                message: this.message || 'A 6-digit OTP has been sent to your email.'
            };
        }
    });
});
